import { useCallback } from 'react';
import { useTranslation } from '../i18n/I18nContext.jsx';

/**
 * Returns a function that prefixes any path with the current language slug.
 *
 *   const lp = useLocalizedPath();
 *   lp('/pricing')   → '/es/pricing'  (when lang === 'es')
 *   lp('/')          → '/es'
 */
export function useLocalizedPath() {
  const { lang } = useTranslation();
  return useCallback(
    (path) => (path === '/' ? `/${lang}` : `/${lang}${path}`),
    [lang],
  );
}
